import { useEffect, useRef, useState } from "react";
import MyCart from "./MyCart";
import { CONSTANTS } from "client/utils/constants";
import { useNavigate, useParams } from "react-router-dom";
import ConfirmationBee from "../../../../../assets/images/ConfirmationBee.svg";
import SuccessBee from "../../../../../assets/images/SuccessBee.svg";
import navOperations from "redux/Navigation/operations";
import { useDispatch, useSelector } from "react-redux";
import TransferAction from "Store/Component/Transfer/TransferAction";
import { ReactToAPI } from "Service/Transfer/ObjectStructure";
import { resetAllAssetOrderData } from "client/utils/AssetUtil";
import selectors from "redux/Navigation/selectors";
import RequisitionAction from "Store/Component/Requisition/RequisitionAction";
import { setAddressDetails } from "Store/Organization/AutoCompleteAddressDetails/AddressDetailsAction";
import { createBillOfSale, setIsBillOfSaleCreated } from "Store/OrderManagement/BillOfSale/BillOfSaleAction";
import { getOnlyNumbers } from "client/utils/RequisitionUtil";
import permissions, { isAuthorized } from "client/utils/Permissions";
import { popupInitialData } from "utils";

//There is one interface for disposition i.e. "IDispositionRequest", but for checking updated fields, only below fields are required.
//Thats why created this const array for checking
const dispositionFieldList = [
  'assetDispositionProcessType',
  'assetDispositionProcessTypeId',
  'assetDispositionChoice',
  'assetDispositionChoiceId',
  'assetDispositionSubChoice',
  'assetDispositionSubChoiceId',
  'assetDispositionReasonCode',
  'assetDispositionReasonCodeId',
  'assetDispositionReplacementFleetAssetOrder',
  'assetDispositionReplacementFleetAsset',
  'assetDispositionName',
  'assetDispositionAddress1',
  'assetDispositionAddress2',
  'assetDispositionCity',
  'assetDispositionState',
  'assetDispositionZip',
  'assetDispositionPhone',
  'assetDispositionSalePrice',
  'assetDispositionTotalPrice',
  'assetLocationName',
  'assetLocationContactName',
  'assetLocationEmail',
  'assetLocationContactPhone',
  'assetLocationAddress1',
  'assetLocationAddress2',
  'assetLocationCity',
  'assetLocationState',
  'assetLocationZip'
]

//There is one interface for asset i.e. "IAsset", but for checking updated fields, only below fields are required.
//Thats why created this const array for checking
const assetFieldList = [
  'assetNumber',
  'odometerHourMeter',
  'estimatedDispositionPrice',
  'conditionRating',
  'conditionComment'
]

const MyCartContainer = (props: any) => {
  const dispatch = useDispatch();
  const setTotalPenaltyFee = props?.setTotalPenaltyFee;
  const totalPenaltyFee = props?.totalPenaltyFee;
  const dispatchNav = navOperations.dispatchNav(dispatch);
  const dispatchHeaderNav = navOperations.dispatchHeaderNav(dispatch)

  const {
    orderDetails,
    docList,
    transferOrderNumber,
    orderSuccess,
    transferRequests,
    dispositionList,
    dispositionCartList,
    assets,
    cartAssets,
    reactivationRequests,
    headerNav,
    isCartNotUpdated,
    transferOrderByIdData,
    getUserDetails,
    isSaveAsDraft,
    isChangesOccuredInCart,
    globalPenaltyFlag,
    isCostCenterAvailableForSubmit,
    billOfSaleUrl,
    isBillOfSaleCreated,
    validateAssetsOnSaveResult
  }: any = useSelector((state?: any) => ({
    orderDetails: state.TransferReducer.orderDetails,
    docList: state.UploadAttachmentsReducer.list,
    transferOrderNumber: state.TransferReducer.transferOrderNumber,
    orderSuccess: state.TransferReducer.orderSuccess,
    transferRequests: state.TransferReducer.transferRequests,
    dispositionList: state.TransferReducer.dispositionList,
    dispositionCartList: state.TransferReducer.dispositionCartList,
    assets: state.TransferReducer.assets,
    cartAssets: state.TransferReducer.cartAssets,
    reactivationRequests: state.TransferReducer.reactivationRequests,
    headerNav: selectors.GetHeaderNav(state),
    isCartNotUpdated: state.TransferReducer.isCartNotUpdated,
    transferOrderByIdData: state.TransferOrderReducer.transferOrderByIdData,
    getUserDetails: state.UserProfile.getUserDetails,
    isSaveAsDraft: state.TransferReducer.isSaveAsDraft,
    isChangesOccuredInCart: state.TransferReducer.isChangesOccuredInCart,
    globalPenaltyFlag: state.DispositionPenaltyFeeReducer.globalPenaltyFlag,
    isCostCenterAvailableForSubmit: state.TransferReducer.isCostCenterAvailableForSubmit,
    billOfSaleUrl: state.BillOfSaleReducer.billOfSaleUrl,
    isBillOfSaleCreated: state.BillOfSaleReducer.isBillOfSaleCreated,
    validateAssetsOnSaveResult: state.TransferReducer.validateAssetsOnSaveResult,
  }));

  const [orderData, setOrderData] = useState<any>([]);
  const [requests, setRequests] = useState<any>([]);
  const [allAsset, setAllAsset] = useState<any>([]);
  const [expand, setExpand] = useState(false);
  const [saveType, setSaveType] = useState("");
  const pendingSaveType = useRef<string>("");
  const pendingSaveContext = useRef<any>(null);
  const [isEditOrder, setIsEditOrder] = useState(false);
  const [expandAll, setExpandAll] = useState(false);
  const [isBOSRequired, setIsBOSRequired] = useState<boolean>(false);

  let { id } = useParams();
  useEffect(() => {
    if(id){
      setIsEditOrder(true);
      setAllAsset([])
      dispatch(TransferAction.setAssetCartData([]));
    }
  }, [id]);  

  useEffect(() => {
    setOrderData(orderDetails)
  }, [orderDetails]);

  useEffect(() => {
    if (orderDetails?.requestType?.label == CONSTANTS.TRANSFER) {
      const transferRequestTemp = transferRequests?.length ? transferRequests : []
      const requestsWithAssets =  transferRequestTemp?.filter((request:any) => assets?.some((asset:any) => request?.requestIndex === asset?.requestIndex))
      requestsWithAssets.forEach((transferData : any) => transferData.expand = transferData.expand ?? true)
      setRequests(requestsWithAssets);
    }
    if (orderDetails?.requestType?.label === CONSTANTS.DISPOSITION) {
      if(dispositionCartList != undefined || dispositionCartList?.length > 0){
        let temp = [];
        temp.push(dispositionCartList)
        temp.forEach((transferData : any) => transferData.expand = transferData.expand ?? true)
        setRequests(temp);
      }
    }
    if (orderDetails?.requestType?.label == CONSTANTS.REACTIVATION) {
      reactivationRequests.forEach((transferData : any) => transferData.expand = transferData.expand ?? true)
      setRequests(reactivationRequests);
    }
  }, [transferRequests, dispositionCartList, reactivationRequests, assets])

  useEffect(() => {
    if (cartAssets?.length || assets?.length) {
      if (orderDetails?.requestType?.label === CONSTANTS.DISPOSITION) {
        if (cartAssets?.length > 0) {
          cartAssets.forEach((assets_data: any, index: any) => assets_data.hide = assets?.length !== 1)
          setAllAsset(cartAssets);
          dispatch(TransferAction.setAllCartAsset(cartAssets))
          setExpandAll(cartAssets?.length === 1)
        }
      } else if (orderDetails?.requestType?.label != CONSTANTS.DISPOSITION && orderDetails?.requestType?.label != undefined && orderDetails?.requestType?.label != null && orderDetails?.requestType?.label?.toString().trim()?.length != 0) {
        assets?.forEach((assets_data: any, index: any) => assets_data.hide = assets?.length !== 1)
        setAllAsset(assets);
        dispatch(TransferAction.setAllCartAsset(assets))
        setExpandAll(assets?.length === 1)
      }
    }
  }, [assets, cartAssets])

  useEffect(()=>{
    if(billOfSaleUrl?.attachmentUrl?.length){
      dispatch(setIsBillOfSaleCreated(true))
    }
  },[billOfSaleUrl])

  useEffect(()=>{
    if(orderDetails?.requestType?.label == CONSTANTS.DISPOSITION &&
      dispositionCartList?.assetDispositionChoice?.length && 
      (dispositionCartList?.assetDispositionChoice == CONSTANTS.DISPOSITION_CHOICES.SELL_TO_OWNED_THIRD_PARTY || 
      dispositionCartList?.assetDispositionChoice == CONSTANTS.DISPOSITION_CHOICES.SELL_TO_LEASED_THIRD_PARTY)){
      setIsBOSRequired(true)
    }else{
      setIsBOSRequired(false)
    }
  }, [dispositionCartList?.assetDispositionChoice])

  const handleClickMain = (index: any) => {
    const tempReq = requests
    tempReq.forEach((req: any, i: any) => {
      if (i === index) {
        req.expand = !req.expand
      }
    })
    setRequests([...tempReq])
    dispatch(TransferAction.setTransferRequestData([...tempReq]))
  }

  const handleAssetExpand = (requestIndex: any, itemIndex: any) => {
    const tempAsset = allAsset;
    tempAsset.forEach((asset: any, index: any) => {
      if (index === requestIndex) {
        asset.hide = !asset.hide;
      }
    })
    setAllAsset([...tempAsset]);
  }

  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comments: ""
  });

  const [confirmationPopupcontent, setConfirmationPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comments: "",
    additionalBtnnavigateTo: "",
    popupOutlinebtnOnclick: () => { },
    popupPrimarybtnOnclick: () => { },
    popupConfirmatioAdditionalbtnOnclick: () => { },
    isAdditionalConfirmationBtn: false
  });

  useEffect(() => {
    if(isSaveAsDraft){
    setSaveType(CONSTANTS.ORDER_SAVE)
    }else{
      setSaveType("")
    }
  },[isSaveAsDraft])

  const orderSuccessResponsePopUp = () => {    
    const labelName = orderDetails.requestType?.value || "Transfer"
    let popUpDecriptionTxt;
    if (saveType === "Save") {
      if(isSaveAsDraft){
        popUpDecriptionTxt = (
          <>
            <p>{labelName} has been saved to your cart and as a draft order.</p>
          </>
        );
      }else{
        popUpDecriptionTxt = (
          <>
            <p>{labelName} has been saved successfully.</p>
          </>
        );
      }
      dispatch(TransferAction.setIsSaveAsDraft(false))
    } else if (saveType === "Submit") {
      popUpDecriptionTxt = (
        <>
          <p>{labelName} has been created successfully.</p>
          <p>
            <b>{CONSTANTS.LEADR_ORDER_NUMBER} :</b> {transferOrderNumber}
          </p>
        </>
      );
    }

    setPopupcontent({
      ...Popupcontent,
      titleImg: SuccessBee,
      title: CONSTANTS.TITLE_SUCCESS,
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: popUpDecriptionTxt,
      primaryBtnText: "",
      outlineBtnText: "Close",
      popupOutlinebtnOnclick: () => { popupOutlinebtnOnclickComplete(headerNav) },
      isSingleConfirmationBtn: true,
    });
  }

  const orderErrorResponsePopUp = () => {
    let popUpDecriptionTxt = (
      <>
        <p>Error occured while creating the Order Request.</p>
      </>
    );
    let popupTitle = CONSTANTS.TITLE_CONFIRMATION
    if(orderSuccess?.errorMessage != ""){
      popUpDecriptionTxt = (
        <>
          <p>{orderSuccess?.errorMessage}</p>
        </>
      );
      popupTitle = "WARNING"
    }
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: popupTitle,
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: popUpDecriptionTxt,
      primaryBtnText: "",
      outlineBtnText: "Close",
      popupOutlinebtnOnclick: () => { 
        hideDialog()
        dispatch(TransferAction.setOrderCreationSuccess({}))
      },
      isSingleConfirmationBtn: true,
    });
  }

  useEffect(() => {
    if (saveType && (orderSuccess?.hasOwnProperty("orderId") && orderSuccess?.orderId != null ) && transferOrderNumber) {
      orderSuccessResponsePopUp();
      dispatch(RequisitionAction.setIsChangesOccured(false))
      dispatch(TransferAction.setIsChangesOccuredInCart(false))
    } else if (saveType && (orderSuccess?.hasOwnProperty("orderId"))) {
      orderErrorResponsePopUp();
    }
  }, [saveType, orderSuccess, transferOrderNumber]);

  useEffect(() => {
    if (!validateAssetsOnSaveResult || !pendingSaveType.current || !pendingSaveContext.current) return;

    const failed = validateAssetsOnSaveResult.filter((r: any) => !r.isValid);

    if (failed.length > 0) {
      const isDisposition = orderDetails?.requestType?.label === CONSTANTS.DISPOSITION;
      const sourceAssets = cartAssets?.length > 0 ? cartAssets : assets;
      const updatedAssets = sourceAssets?.map((a: any) => {
        const failedEntry = failed.find((r: any) => r.assetNumber == a.assetNumber);
        if (failedEntry) {
          const orderRef = failedEntry.conflictingOrderNumber ? ` LEADR # ${failedEntry.conflictingOrderNumber}` : "";
          return { ...a, assetError: failedEntry.validationMessage + orderRef };
        }
        return { ...a, assetError: "" };
      });

        if (isDisposition) {
        dispatch(TransferAction.setAssetCartData(updatedAssets));
      } else {
        dispatch(TransferAction.setAssetData(updatedAssets));
      }
      // Also update allAsset local state directly so the UI re-renders immediately
      setAllAsset([...updatedAssets]);

        // Show popup listing invalid asset numbers — same pattern as purchaseOrder-container.tsx
      const invalidAssetNumbers = failed.map((r: any) => r.assetNumber);
      setPopupcontent({
        ...popupInitialData,
        titleImg: ConfirmationBee,
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: (
          <p>Please enter the valid asset in items {invalidAssetNumbers.map((num: any) => <span key={num}>{num} </span>)} before saving.</p>
        ),
        outlineBtnText: "Ok",
        popupOutlinebtnOnclick: popupOutlinebtnOnclick,
        isSingleConfirmationBtn: true,
      });
    } else {
      dispatch(TransferAction.setOrderCreationSuccess({}))
      setSaveType(pendingSaveType.current);
      ReactToAPI(pendingSaveContext.current);
    }

    dispatch(TransferAction.setValidateAssetsOnSave(null));
    pendingSaveType.current = "";
    pendingSaveContext.current = null;
  }, [validateAssetsOnSaveResult]);

  const compareCart = () => {
    let isUpdated = false;
    //check is asset updated
    if (isCartNotUpdated) {
      isUpdated = true;
      return isUpdated;
    }
    //compare dipositionList
    if(orderDetails?.requestType?.label === CONSTANTS.DISPOSITION){
      dispositionFieldList?.forEach(element => {
      if (dispositionList[element] != dispositionCartList[element]) {
        isUpdated = true;
        return isUpdated;
      }
      });
    }

    //compare assetList length
    if (assets?.length != cartAssets?.length) {
      isUpdated = true;
      return isUpdated;
    }

    //compare assetList
      assets.forEach((item: any) => {
      const findAsset = cartAssets?.filter((i: any) => i?.assetNumber === item?.assetNumber);
        if (findAsset?.length > 0) {
          const tempAsset = findAsset[0];
          assetFieldList.forEach(element => {
            if (item[element] != tempAsset[element]) {
              isUpdated = true;
              return isUpdated;
            }
          })
          if (item?.attachments?.length != tempAsset?.attachments?.length) {
            isUpdated = true;
            return isUpdated;
          }
        } else {
          isUpdated = true;
          return isUpdated;
        }
      });
    
    return isUpdated;
  }

  const handleClickComplete = (type: any) => {
    if (assets?.length === 0 || assets?.length === undefined || assets?.length === '') {
      let decriptionTxt = (
        <div>
          <p>My cart is empty</p>
          <p>Please add asset details</p>
        </div>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Ok",
        popupOutlinebtnOnclick: popupOutlinebtnOnclick,
        isSingleConfirmationBtn: true,
      })
    }
    else {
        const isUpdated = compareCart();
        if (isUpdated) {
          let decriptionTxt = (
            <div>
              <p>The cart is not updated.</p>
              <p>Do you want to continue without updating cart?</p>
            </div>
          );
          setPopupcontent({
            ...Popupcontent,
            titleImg: ConfirmationBee,
            title: "CONFIRMATION",
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: decriptionTxt,
            primaryBtnText: "Yes",
            outlineBtnText: "No",
            popupOutlinebtnOnclick: popupOutlinebtnOnclick,
            popupPrimarybtnOnclick: () => {
              hideDialog();
              if (type === CONSTANTS.ORDER_SUBMIT) {
                const submitContext = {
                  orderDetails, getUserDetails, type, dispatch, docList,
                  transferOrderNumber, transferRequests, dispositionCartList,
                  assets, reactivationRequests, globalPenaltyFlag,
                  transferOrderByIdData, billOfSaleUrl
                };
                const sourceAssets = cartAssets?.length > 0 ? cartAssets : assets;
                // Clear any previous assetErrors before re-validating
                const clearedAssets = sourceAssets?.map((a: any) => ({ ...a, assetError: "" }));
                dispatch(TransferAction.setAssetCartData(clearedAssets));
                dispatch(TransferAction.setAssetData(clearedAssets));
                pendingSaveType.current = type;
                pendingSaveContext.current = submitContext;
                dispatch(TransferAction.setValidateAssetsOnSave(null));
                dispatch(TransferAction.getValidateAssetsOnSave({
                  requestType: orderDetails?.requestType?.label,
                  assets: sourceAssets?.map((a: any) => ({
                    assetNumber: a.assetNumber,
                    transDispoReactivationAssetDetailId: a.transferDispoReactivationAssetDetailId || 0
                  }))
                }));
              } else {
                dispatch(TransferAction.setOrderCreationSuccess({}))
                setSaveType(type);
                ReactToAPI({
                  orderDetails,
                  getUserDetails,
                  type,
                  dispatch,
                  docList,
                  transferOrderNumber,
                  transferRequests,
                  dispositionCartList,
                  assets,
                  reactivationRequests,
                  globalPenaltyFlag,
                  billOfSaleUrl
                })
              }
            },
            isSingleConfirmationBtn: false,
          });
        } else {
          if (type === CONSTANTS.ORDER_SUBMIT) {
            const submitContext = {
              orderDetails, getUserDetails, type, dispatch, docList,
              transferOrderNumber, transferRequests, dispositionCartList,
              assets, reactivationRequests, globalPenaltyFlag,
              transferOrderByIdData, billOfSaleUrl
            };
            const sourceAssets = cartAssets?.length > 0 ? cartAssets : assets;
            // Clear any previous assetErrors before re-validating
            const clearedAssets = sourceAssets?.map((a: any) => ({ ...a, assetError: "" }));
            dispatch(TransferAction.setAssetCartData(clearedAssets));
            dispatch(TransferAction.setAssetData(clearedAssets));
            pendingSaveType.current = type;
            pendingSaveContext.current = submitContext;
            dispatch(TransferAction.setValidateAssetsOnSave(null));
            dispatch(TransferAction.getValidateAssetsOnSave({
              requestType: orderDetails?.requestType?.label,
              assets: sourceAssets?.map((a: any) => ({
                assetNumber: a.assetNumber,
                transDispoReactivationAssetDetailId: a.transferDispoReactivationAssetDetailId || 0
              }))
            }));
          } else {
            dispatch(TransferAction.setOrderCreationSuccess({}))
            setSaveType(type);
            ReactToAPI({
              orderDetails,
              getUserDetails,
              type,
              dispatch,
              docList,
              transferOrderNumber,
              transferRequests,
              dispositionCartList,
              assets,
              reactivationRequests,
              globalPenaltyFlag,
              transferOrderByIdData,
              billOfSaleUrl
            })
          }
        }
    }
  };

  const hideDialog = () => {
    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
  }

  const hideConfirmationDialog = () => {
    setConfirmationPopupcontent({ ...confirmationPopupcontent, isDialogVisible: false })
  }

  const popupOutlinebtnOnclick = () => {
    hideDialog();
  };

  const navigate = useNavigate();

  const redirectToOrderManagement = (item: any) => {
    dispatch(TransferAction.setOrderCreationSuccess({}));
    resetAllAssetOrderData(dispatch);
    dispatchNav(item);
    dispatchHeaderNav(item);
    navigate('/ordermanagement/')
  }
  const popupPrimarybtnOnclick = (item: any) => {
    dispatch(RequisitionAction.setIsChangesOccured(false));
    dispatch(TransferAction.setIsChangesOccuredInCart(false))
    redirectToOrderManagement(item);
    hideDialog();
  };

  const popupOutlinebtnOnclickComplete = (item: any) => {
    if (!orderSuccess?.hasOwnProperty("orderId") || orderSuccess?.orderId == null ) {
      hideDialog();
    } else {
      popupPrimarybtnOnclick(item)
      dispatch(setAddressDetails({}))
    }
  }

  const resetDefaultState = () => {
    resetAllAssetOrderData(dispatch);
  }

  const draftSaveConfirmationPopup = () => {
    let decriptionTxt = (
      <p>Do you need to save the cart values as draft?</p>
    );
    
    // Check if user has permission to save drafts
    const canSaveDraft = isAuthorized(permissions.RequisitionsCreateUpdate) || isAuthorized(permissions.CreateUpdateTransfers);
    
    setConfirmationPopupcontent({
      ...confirmationPopupcontent,
      titleImg: ConfirmationBee,
      title: "DRAFT CONFIRMATION",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      outlineBtnText: "No",
      primaryBtnText: "Yes",
      additionalBtnText: "Cancel",
      isPrimaryBtnDisabled: !canSaveDraft, 
      popupConfirmationOutlinebtnOnclick: () => {
        dispatch(RequisitionAction?.setIsChangesOccured(false))
        dispatch(TransferAction.setIsChangesOccuredInCart(false))
        dispatch(TransferAction.setIsEditOrder(false));
        dispatch(TransferAction.setTransferOrderDetails({}));
        navigate('/ordermanagement');
        dispatchNav(headerNav);
        dispatchHeaderNav(headerNav);
        resetDefaultState();
        hideConfirmationDialog();
      },
      popupConfirmationPrimarybtnOnclick: () => {
        // Only proceed if user has permission
        if (!canSaveDraft) return;
        
        hideConfirmationDialog();
        let type : any = CONSTANTS.ORDER_SAVE
        dispatch(TransferAction.setIsSaveAsDraft(true))
        dispatch(TransferAction.setIsChangesOccuredInCart(false))
        dispatch(TransferAction.setTransferOrderNumber(""))
        dispatch(TransferAction.setOrderCreationSuccess({}))
            ReactToAPI({
              orderDetails,
              getUserDetails,
              type,
              dispatch,
              docList,
              transferOrderNumber,
              transferRequests,
              dispositionCartList,
              assets,
              reactivationRequests,
              globalPenaltyFlag,
              billOfSaleUrl
            })
      },
      popupConfirmatioAdditionalbtnOnclick: () => {
        hideConfirmationDialog();
      },
      isSingleConfirmationBtn: false,
      isAdditionalConfirmationBtn: true
    });
  }

  const handleClickCancel = () => {
    if(cartAssets?.length || assets?.length){
      if(((orderDetails?.requestType?.label === CONSTANTS.DISPOSITION || orderDetails?.requestType?.label === CONSTANTS.REACTIVATION) && cartAssets?.length && (transferOrderByIdData?.orderStatus == undefined)) || (orderDetails?.requestType?.label === CONSTANTS.TRANSFER && assets?.length && (transferOrderByIdData?.orderStatus == undefined)) || isChangesOccuredInCart){
        draftSaveConfirmationPopup();
      }else {
        let decriptionTxt = (
          <p>Are you sure you want to cancel the New Order</p>
        );
        setPopupcontent({
          ...Popupcontent,
          titleImg: ConfirmationBee,
          title: "CONFIRMATION",
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: decriptionTxt,
          primaryBtnText: "Yes",
          outlineBtnText: "No",
          popupOutlinebtnOnclick: popupOutlinebtnOnclick,
          isSingleConfirmationBtn: false,
        });
      } 
    }
    
  };

  const handleExpandAllCheckbox = () => {
    setExpandAll(!expandAll)
    const tempReq = requests
    tempReq.forEach((req: any, i: any) => {
      req.expand = !expand
    })
    setRequests([...tempReq]);
    dispatch(TransferAction.setTransferRequestData([...tempReq]))
    
    const tempAsset = allAsset;
    tempAsset?.forEach((asset: any, index: any) => {
      asset.hide = expand
    })
    setAllAsset([...tempAsset]);
    // dispatch(TransferAction.setAllCartAsset([...tempAsset]))
    // dispatch(TransferAction.setAssetData([...tempAsset]))
    setExpand(oldvalue => !oldvalue)
    }
    const deleteInfoPopup = () => {
    let decriptionTxt = (
      <p>Request must contain atleast one asset.</p>
    );
    setPopupcontent({
      ...Popupcontent,
      titleImg: ConfirmationBee,
      title: "Information",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: decriptionTxt,
      outlineBtnText: "Ok",
      popupOutlinebtnOnclick: popupOutlinebtnOnclick,
      isSingleConfirmationBtn: true,
    });
  }
  const handleDeleteAsset = (removeAsset: any, disposedAssetNumber: any) => {
    dispatch(RequisitionAction?.setIsChangesOccured(true))
    if (orderDetails?.requestType?.label === CONSTANTS.DISPOSITION || orderDetails?.requestType?.label === CONSTANTS.REACTIVATION) {
     
      if (allAsset?.length == 1) {
        deleteInfoPopup()
      } else {
        const tempCartAsset = allAsset?.filter((asset: any) => asset?.assetNumber !== disposedAssetNumber);
        tempCartAsset.forEach((asset: any) => {
          if(asset.assetIndex > removeAsset.assetIndex){
            asset.assetIndex = asset.assetIndex - 1
          }
        })
        setAllAsset([...tempCartAsset]);
        dispatch(TransferAction.setAllCartAsset([...tempCartAsset]))
        dispatch(TransferAction.setAssetCartData([...tempCartAsset]))
        const removeAssetTemp = assets?.find((item: any) => item.assetNumber == disposedAssetNumber)
        let totalPenaltyFeeTemp = totalPenaltyFee - removeAssetTemp?.dispositionPenalityFee;
        setTotalPenaltyFee(totalPenaltyFeeTemp)
        const tempAsset = assets.filter((asset: any) => asset?.assetNumber !== disposedAssetNumber);
        tempAsset.forEach((asset: any) => {
          if(asset.assetIndex > removeAsset.assetIndex){
            asset.assetIndex = asset.assetIndex - 1
          }
        })
        dispatch(TransferAction.setAssetData([...tempAsset]))

        if (tempCartAsset?.length <= 0) {
          dispatch(TransferAction.setCartIDisposition([]))
        }
        if(transferOrderByIdData?.orderStatus == "Saved"){
          dispatch(TransferAction.setIsChangesOccuredInCart(true))
        }
      }
    } else {
      const assetCount = allAsset?.filter((asset: any) => asset?.requestIndex === removeAsset?.requestIndex).length;
      if (assetCount == 1) {
        deleteInfoPopup()
      } else {
        const tempAsset = allAsset?.filter((asset: any) => asset.assetNumber !== removeAsset.assetNumber);
        tempAsset.forEach((asset: any) => {
          if(asset.assetIndex > removeAsset.assetIndex){
            asset.assetIndex = asset.assetIndex - 1
          }
        })
        setAllAsset([...tempAsset]);
        dispatch(TransferAction.setAllCartAsset([...tempAsset]))
        dispatch(TransferAction.setAssetData([...tempAsset]))
        dispatch(TransferAction.setAssetCartData([...tempAsset]))
        if(transferOrderByIdData?.orderStatus == "Saved"){
          dispatch(TransferAction.setIsChangesOccuredInCart(true))
        }
      }

    }
  }

  const handleDeleteRequest = (requestIndex: any) => {    
    if(transferOrderByIdData?.orderStatus == "Saved"){
      dispatch(TransferAction.setIsChangesOccuredInCart(true))
    }
    dispatch(RequisitionAction?.setIsChangesOccured(true))
    if (orderDetails?.requestType?.label === CONSTANTS.DISPOSITION || orderDetails?.requestType?.label === CONSTANTS.REACTIVATION) {
      dispatch(TransferAction.setIsLastRequestDeleted(true))
      setTotalPenaltyFee(0)
    } else {
      if (transferRequests?.length === 1) {
        dispatch(TransferAction.setIsLastRequestDeleted(true))
        return
      }
      const tempAsset = allAsset?.filter((asset: any) => asset?.requestIndex !== requestIndex);
      const tempRequest = transferRequests.filter((request: any) => request?.requestIndex !== requestIndex)
      setAllAsset([...tempAsset]);
      dispatch(TransferAction.setAllCartAsset([...tempAsset]))
      dispatch(TransferAction.setAssetData([...tempAsset]))
      dispatch(TransferAction.setAssetCartData([...tempAsset]))
      dispatch(TransferAction.setTransferRequestData(tempRequest))
    }
  }

  const getOdometerLabel = (asset: any) => {
    if (asset?.isOdometerRequired) {
      return "Mileage"
    }
    if (asset?.glCategory?.toLowerCase()?.includes("mower")) {
      return "Hour Meter"
    }
    return "Odometer / Meter";
  }

  const getVinSerialLabel = (asset: any) => {
    let label = "";
    if (asset.isOdometerRequired && asset?.assetNumber) {
      label = "Vin #"
    }else if(asset?.assetNumber){
      label = "Serial #"
    }else{
      label = "VIN / Serial #"
    }
    return label;
  }

  const isValidForPenaltyFee = (selectedOption?: any) => {
    if (selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_OWNED_ASSET_NO_TITLE || 
      selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_LEASED_ASSET_NO_TITLE ||
      selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_OWNED_ASSET_TITLED || 
      selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_LEASED_ASSET_TITLED) {
      return true
    } else {
      return false
    }
  }
  const createBOS = () => {
    const assetInfo = assets?.map((asset: any) => {
      return {
        "assetNumber": asset?.assetNumber.toString(),
        "serialNumber": asset?.serialNumber,
        "year": parseInt(asset?.modelYear),
        "make": asset?.manufacturerName ? asset?.manufacturerName : "",
        "model": asset?.model ? asset?.model : "",
        "estimatedDispositionPrice": (asset?.estimatedDispositionPrice !== "") ? parseFloat(getOnlyNumbers(asset?.estimatedDispositionPrice)) : 0,
        "description": asset?.description ? asset?.description : "",
      }
    });
    
    const bos = {
      "orderRequestId": id ? id : 0,
      "orderRequestedBy": getUserDetails?.firstName + " " + getUserDetails?.lastName,
      "branch": orderDetails?.selectedBranch?.label,
      "phoneNumber": dispositionCartList?.assetDispositionPhone,
      "name": dispositionCartList?.assetDispositionName,
      "address1": dispositionCartList?.assetDispositionAddress1,
      "address2": dispositionCartList?.assetDispositionAddress2,
      "city": dispositionCartList?.assetDispositionCity,
      "state": dispositionCartList?.assetDispositionState,
      "zip": dispositionCartList?.assetDispositionZip,
      "assetInfo": assetInfo,
      "jobTitle": getUserDetails?.title,
      "areaCode": dispositionCartList?.assetDispositionZip,
      "totalPrice": dispositionCartList?.assetDispositionTotalPrice !="" ? parseFloat(getOnlyNumbers(dispositionCartList?.assetDispositionTotalPrice)) : 0,
    }
    
    dispatch(createBillOfSale(bos));
  }

  const handleCreateBOS = () => {
    if (orderDetails?.requestType?.label === CONSTANTS.DISPOSITION) {
      const isUpdated = compareCart();
      if (isUpdated) {
        let decriptionTxt = (
          <div>
            <p>The cart is not updated.</p>
            <p>Do you want to continue without updating cart?</p>
          </div>
        );
        setPopupcontent({
          ...Popupcontent,
          titleImg: ConfirmationBee,
          title: "CONFIRMATION",
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: decriptionTxt,
          primaryBtnText: "Yes",
          outlineBtnText: "No",
          popupOutlinebtnOnclick: popupOutlinebtnOnclick,
          popupPrimarybtnOnclick: () => {
            createBOS();
            hideDialog();
          },
          isSingleConfirmationBtn: false,
        });
      } else {
        createBOS();
      }
    }
  }

  return (
    <MyCart
      orderData={orderData}
      handleAssetExpand={handleAssetExpand}
      requestType={props.requestType}
      handleClickMain={handleClickMain}
      Popupcontent={Popupcontent}
      handleClickComplete={handleClickComplete}
      hideDialog={hideDialog}
      popupPrimarybtnOnclick={popupPrimarybtnOnclick}
      handleClickCancel={handleClickCancel}
      handleExpandAllCheckbox={handleExpandAllCheckbox}
      handleDeleteAsset={handleDeleteAsset}
      handleDeleteRequest={handleDeleteRequest}
      mobile={props.mobile}
      requests={requests}
      allAsset={allAsset?.sort((a: any,b: any)=> b?.assetIndex - a?.assetIndex)}
      getOdometerLabel={getOdometerLabel}
      getVinSerialLabel={getVinSerialLabel}
      transferOrderByIdData={transferOrderByIdData}
      isEditOrder={isEditOrder}
      expandAll={expandAll}
      confirmationPopupcontent = {confirmationPopupcontent}
      isValidForPenaltyFee = {isValidForPenaltyFee}
      globalPenaltyFlag={globalPenaltyFlag}
      isCostCenterAvailableForSubmit = {isCostCenterAvailableForSubmit}
      isBOSCreated = {isBOSRequired ? isBillOfSaleCreated : true}
      isBOSRequired={isBOSRequired}
      handleCreateBOS={handleCreateBOS}
      billOfSaleUrl={billOfSaleUrl}
    />
  )
};

export default MyCartContainer;
